export type ErrorCode = "UNKNOWN_ERROR" | "NETWORK_ERROR" | "SERVER_ERROR";

export class ApplicationError extends Error {
  constructor(readonly code: ErrorCode, message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export function isApplicationError(value: any): value is ApplicationError {
  return value instanceof ApplicationError;
}

export function isError(value: any): value is Error {
  return value instanceof Error;
}

export function getErrorCode(error: any): ErrorCode {
  return isApplicationError(error) ? error.code : "UNKNOWN_ERROR";
}

export function getErrorMessage(error: any, defaultMessage?: string) {
  return (isError(error) ? error.message : defaultMessage) || defaultMessage;
}
